import { api, ApiError } from '../lib/api'
import type {
  StrokesGainedOverview,
  StrokesGainedOverviewResponse,
  StrokesGainedRound,
  StrokesGainedRoundResponse,
} from '../lib/strokesGainedTypes'
import { useGatedBook } from './useGatedBook'

export const STROKES_GAINED_OVERVIEW_PATH = '/golf/strokes_gained'

export function useStrokesGainedOverview(enabled: boolean) {
  const book = useGatedBook<StrokesGainedOverview>({
    key: STROKES_GAINED_OVERVIEW_PATH,
    enabled,
    read: () =>
      api
        .get<StrokesGainedOverviewResponse>(STROKES_GAINED_OVERVIEW_PATH)
        .then((payload) => payload.strokes_gained),
    whenFaulty: 'Could not read strokes gained just now.',
  })

  return {
    overview: book.data,
    isLoading: book.isLoading,
    error: book.error,
    membershipRequired: book.membershipRequired,
    refresh: book.refresh,
  }
}

/** A 403/404 is one quiet absence, never an ownership oracle on a readable round. */
export function useRoundStrokesGained(roundId: string, enabled: boolean) {
  const path = `/golf/rounds/${roundId}/strokes_gained`
  const book = useGatedBook<StrokesGainedRound | null>({
    key: path,
    enabled,
    read: () =>
      api
        .get<StrokesGainedRoundResponse>(path)
        .then((payload) => payload.strokes_gained)
        .catch((error: unknown) => {
          if (error instanceof ApiError && (error.status === 403 || error.status === 404)) return null
          throw error
        }),
    whenFaulty: 'Could not read strokes gained for this round.',
  })

  return { result: book.data, isLoading: book.isLoading, error: book.error, refresh: book.refresh }
}
